// extracted by mini-css-extract-plugin
module.exports = {"button":"RulesModal_button__1k0Uk","form":"RulesModal_form__TZDXs","label":"RulesModal_label__KFHK3","input":"RulesModal_input__FHfbD"};